import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useParams, useLocation } from "react-router-dom";
import DistributorHomeTab from "./DistributorHomeTab";
import DistributorDetailsTab from "./DistributorDetailsTab";
import APIService from "../../Service/APIService";
import DistCommissionContracts from "./DistCommissionContracts";
import TitleBar from "../../common/title-bar/title-bar.js";
import Button from "../../common/button/button.js";
import Text from "../../common/typography/text.js";
import { timeframeButtons } from "../Utils/Constants.js";
import ReferralContractsDashboard from "../DistributorReferralContract/ReferralContractsDashboard.js";
import CommissionStatementsDistHome from "./CommissionStatementsDistHome.js";
import { Modal } from "antd";
import Select from "react-select";
import Swal from "sweetalert2";
import { useAuth } from "../AuthProvider.js";
import { hasPermission } from "../../Config/permissions.js";
import DatePickerComponent from "../../common/date-picker/index.js";
import TabFade from "../../common/tab-fade";
import { Skeleton } from "antd";

const DistributorDetails = () => {
  const { user } = useAuth();
  const userData = user;
  const { id } = useParams();
  const [distributorDetails, setDistributorDetails] = useState(null);
  const location = useLocation();
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const distributorNameFromQuery = useMemo(() => {
    return (queryParams.get("distributorName") || "").trim();
  }, [queryParams]);
  const isNewDistributor = !id;

  const defaultSegment = useMemo(() => {
    if (isNewDistributor) {
      return "Distributor Details";
    }

    const tab = queryParams.get("tab");
    if (tab === "details") {
      return "Distributor Details";
    } else if (tab === "home") {
      return "Distributor Home";
    } else if (tab === "commstatements") {
      return "Commission Statements";
    } else if (tab === "commcontracts") {
      return "Commission Contracts";
    } else if (tab === "refcontracts") {
      return "Referral Contracts";
    } else {
      return "Distributor Home";
    }
  }, [isNewDistributor, queryParams]);

  useEffect(() => {
    setSelectedSegment(defaultSegment);
  }, [defaultSegment]);

  const [selectedSegment, setSelectedSegment] = useState(defaultSegment);
  const [filterButton, setFilterButton] = useState("YTD");

  const fetchDistributorDetails = useCallback(async () => {
    if (isNewDistributor) return null;
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `getdistributorbyid?ID=${id}`
    );
    const data = response?.data?.data;
    setDistributorDetails(data);
    return data;
  }, [id, isNewDistributor]);

  useEffect(() => {
    console.log(userData, "user data");
    if (!userData) return;

    if (userData.Type === "Distributor") {
      if (String(id) !== String(userData.DistributorID)) {
        window.location.href = "/";
        return;
      }
    } else if (userData.Type === "Account") {
      window.location.href = "/";
      return;
    } else if (userData.Type === "Manufacturer") {
      window.location.href = "/";
      return;
    }

    if (isNewDistributor) {
      setDistributorDetails({
        DistributorName: distributorNameFromQuery,
        IsActive: true,
        EnableCommissionModule: true,
      });
      return;
    }

    fetchDistributorDetails().then((data) => {
      console.log("Fetched Distributor Data: ", data);
    });
    // setBreadcrumbs([
    //   { label: "All Distributors", path: "/DistributorDashboard" },
    // ]);
  }, [
    id,
    isNewDistributor,
    distributorNameFromQuery,
    fetchDistributorDetails,
    userData,
  ]);

  const handleSegmentChange = (value) => {
    const url = new URL(window.location);
    if (value === "Distributor Details") {
      url.searchParams.set("tab", "details");
      window.history.pushState({}, "", url);
    } else if (value === "Distributor Home") {
      url.searchParams.set("tab", "home");
      window.history.pushState({}, "", url);
    } else if (value === "Commission Statements") {
      url.searchParams.set("tab", "commstatements");
      window.history.pushState({}, "", url);
    } else if (value === "Commission Contracts") {
      url.searchParams.set("tab", "commcontracts");
      window.history.pushState({}, "", url);
    } else if (value === "Referral Contracts") {
      url.searchParams.set("tab", "refcontracts");
      window.history.pushState({}, "", url);
    }
    setSelectedSegment(value);
  };

  const handleFilterButtonChange = (value) => {
    setFilterButton(value);
  };
  const [openDeactivateModal, setOpenDeactivateModal] = useState(false);
  const [remainingDistributors, setRemainingDistributors] = useState([]);
  const [selectedDistributor, setSelectedDistributor] = useState(null);

  const handleDeactivateDistributor = async () => {
    // get all distributors
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend("getdistributors");
    const allDists = response?.data?.data;
    // filter out the current distributor
    const filteredDists = allDists.filter((dist) => String(dist.ID) !== String(id));
    console.log("Filtered Distributors: ", filteredDists);
    setRemainingDistributors(filteredDists);
    // if there are no other distributors, show an error
    setOpenDeactivateModal(true);
  };

  const deactivateDistributor = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will deactivate the distributor and remove all associated users. Any active contracts with this distributor will be terminated with the selected end date.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, deactivate it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const postObj = {
          DistributorID: id,
          ReassignDistributorID: selectedDistributor
            ? selectedDistributor.value
            : null,
          ReassignDistributorName: selectedDistributor
            ? selectedDistributor.label
            : null,
          DeactivateDate: deactivateDate
        };
        const apiServe = new APIService();
        const response = await apiServe.updateDataToBackend(
          postObj,
          `DeactivateDistributor`
        );
        console.log("Deactivate Distributor Response: ", response);
        if (response?.status === 200 || response?.status === 201) {
          Swal.fire(
            "Deactivated!",
            "The distributor has been deactivated successfully.",
            "success"
          ).then(() => {
            window.location.href = "/DistributorDashboard";
          });
        } else {
          Swal.fire(
            "Error!",
            "There was an error deactivating the distributor. Please try again.",
            "error"
          );
        }
      }
    });
  };

  const [deactivateDate, setDeactivateDate] = useState(null);

const entityNameValue = useMemo(() => {
  if (!distributorDetails) {
    return (
          <Skeleton.Input active style={{ width: 60, height: 16 }} />
        );
  }
  return "Distributor";
}, [distributorDetails]);

const labelValue = useMemo(() => {
  if (!distributorDetails) {
    return <Skeleton.Input active style={{ width: 260, height: 20 }} />;
  }
  return distributorDetails.DistributorName;
}, [distributorDetails]);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
      <>
        <TitleBar
          entityName={entityNameValue}
          label={labelValue}
          statusIndicatorStatus={
            distributorDetails
              ? distributorDetails.IsActive
                ? "Active"
                : "Inactive"
              : ""
          }
          statusIndicatorStatusType={
            distributorDetails
              ? distributorDetails.IsActive
                ? "success"
                : "failure"
              : ""
          }
          filterBarComponents={
            <>
              <Button
                isActive={selectedSegment === "Distributor Home"}
                variant="timeframe"
                onClick={() => handleSegmentChange("Distributor Home")}
              >
                Home
              </Button>
              <Button
                isActive={selectedSegment === "Distributor Details"}
                variant="timeframe"
                onClick={() => handleSegmentChange("Distributor Details")}
              >
                Details
              </Button>
              {(userData.Type === "Admin" ||
                userData.Type === "ASD" ||
                userData.Type === "Authorizer" ||
                userData.Type === "Viewer" ||
                userData.Type === "Distributor") &&
                hasPermission(userData, "commission_stmt.view") &&
                distributorDetails?.EnableCommissionModule && (
                  <Button
                    isActive={selectedSegment === "Commission Statements"}
                    variant="timeframe"
                    onClick={() => handleSegmentChange("Commission Statements")}
                  >
                    Commission Statements
                  </Button>
                )}
              {(userData.Type === "Admin" ||
                userData.Type === "ASD" ||
                userData.Type === "Authorizer" ||
                userData.Type === "Viewer" ||
                userData.Type === "Distributor") &&
                hasPermission(userData, "dist_contract.view") &&
                distributorDetails?.EnableCommissionModule && (
                  <>
                    <Button
                      isActive={selectedSegment === "Commission Contracts"}
                      variant="timeframe"
                      onClick={() =>
                        handleSegmentChange("Commission Contracts")
                      }
                    >
                      Commission Contracts
                    </Button>
                    <Button
                      isActive={selectedSegment === "Referral Contracts"}
                      variant="timeframe"
                      onClick={() => handleSegmentChange("Referral Contracts")}
                    >
                      Referral Contracts
                    </Button>
                  </>
                )}
            </>
          }
          rightFilterBarComponents={
            selectedSegment === "Distributor Home" ? (
              <>
                <Text variant="buttonText">Timeframe</Text>
                {timeframeButtons.map((btn) => {
                  return (
                    <Button
                      key={btn}
                      isActive={filterButton === btn}
                      variant="timeframe"
                      onClick={() => handleFilterButtonChange(btn)}
                    >
                      {btn}
                    </Button>
                  );
                })}
              </>
            ) : (
              <></>
            )
          }
        />

        <TabFade activeKey={selectedSegment} style={{ marginTop: "32px" }}>
          {selectedSegment === "Distributor Home" && (
            <DistributorHomeTab
              distributorDetails={distributorDetails}
              filterButton={filterButton}
            />
          )}
          {selectedSegment === "Distributor Details" && (
            distributorDetails ? (
              <DistributorDetailsTab
                distributorData={distributorDetails}
                onDistributorUpdated={fetchDistributorDetails}
                onDeactivateDistributor={handleDeactivateDistributor}
              />
            ) : null
          )}
          {(userData.Type === "Admin" ||
            userData.Type === "ASD" ||
            userData.Type === "Authorizer" ||
            userData.Type === "Viewer" ||
            userData.Type === "Distributor") &&
            hasPermission(userData, "commission_stmt.view") &&
            selectedSegment === "Commission Statements" && distributorDetails?.EnableCommissionModule && (
              <CommissionStatementsDistHome
                distributorData={distributorDetails}
              />
            )}
          {(userData.Type === "Admin" ||
            userData.Type === "ASD" ||
            userData.Type === "Authorizer" ||
            userData.Type === "Viewer" ||
            userData.Type === "Distributor") &&
            hasPermission(userData, "dist_contract.view") &&
            selectedSegment === "Commission Contracts" && distributorDetails.EnableCommissionModule && (
              <DistCommissionContracts distributorData={distributorDetails} />
            )}
          {(userData.Type === "Admin" ||
            userData.Type === "ASD" ||
            userData.Type === "Authorizer" ||
            userData.Type === "Viewer" ||
            userData.Type === "Distributor") &&
            hasPermission(userData, "dist_contract.view") &&
            selectedSegment === "Referral Contracts" && distributorDetails.EnableCommissionModule && (
              <ReferralContractsDashboard />
            )}
        </TabFade>
      </>
      <Modal
        title="Deactivate Distributor"
        open={openDeactivateModal}
        onOk={deactivateDistributor}
        onCancel={()=> setOpenDeactivateModal(false)}
        centered={true}
        footer={false}
      >
        Deactivating this distributor will remove all associated users. To
        proceed, please select another distributor to reassign its accounts.
        <Select
          options={remainingDistributors.map((dist) => ({
            value: dist.ID,
            label: dist.DistributorName,
          }))}
          placeholder="Select a distributor to reassign accounts"
          isClearable={true}
          isSearchable={true}
          onChange={(selectedOption) => {
            console.log(
              "Selected Distributor for Reassignment: ",
              selectedOption
            );
            setSelectedDistributor(selectedOption);
            // Handle the selected distributor for reassignment here
          }}
        />
        <div className="field-group">
          <DatePickerComponent
            format="MM-DD-YYYY"
            titleText="Set Contract End Date"
            isRequired
            value={deactivateDate}
            onChange={(date) =>
              setDeactivateDate(date)
            }
          />
        </div>
        <Button
          type="primary"
          onClick={deactivateDistributor}
          style={{ background: "#27a907", fontSize: "14px", fontWeight: "600" }}
        >
          Confirm
        </Button>
      </Modal>
    </div>
  );
};

export default DistributorDetails;
